import axios from "axios";
import { cropr } from "../adapter";
import sortBy from "lodash/sortBy";
import { fetchStation } from "./weatherStationActions";
import { jwtClient } from "./authUtils";

export const REQUEST_STATIONS = "REQUEST_STATIONS";
const requestStations = () => {
  return {
    type: REQUEST_STATIONS,
  };
};

export const RECEIVE_STATIONS = "RECEIVE_STATIONS";
const receiveStations = (stations) => {
  return {
    type: RECEIVE_STATIONS,
    stations,
  };
};

export const FAILED_STATIONS = "FAILED_STATIONS";
const failedStations = () => {
  return {
    type: FAILED_STATIONS,
  };
};

export const SELECT_STATION = "SELECT_STATION";
const selectStation = (stationId) => {
  window.localStorage.setItem("defaultWeatherStation" + cropr.farm.id, stationId);
  return {
    type: SELECT_STATION,
    stationId,
  };
};

export const selectFetchStation = (
  apiUrl,
  stationId,
  showAllMeasurements,
  showFiveMinutesMeasurements,
  fetchPeriod
) => {
  return (dispatch) => {
    dispatch(selectStation(stationId));
    return dispatch(
      fetchStation(apiUrl, stationId, showAllMeasurements, showFiveMinutesMeasurements, fetchPeriod)
    );
  };
};

export const fetchStations = (apiUrl) => {
  return async (dispatch) => {
    dispatch(requestStations());
    try {
      var url = apiUrl + "/api/product/installation/weather/";
      let featuresHeader = "";
      if (!cropr.permissions.staff && cropr.features && cropr.features.dacom_online_weather) {
        featuresHeader = "dacom_online_weather=" + cropr.features.dacom_online_weather;
      }

      const response = await jwtClient.withJWT(async (jwt) => {
        return axios.get(url, {
          headers: { Authorization: "JWT " + jwt, features: featuresHeader },
        });
      });

      let stations = response.data;

      var selectedStation;
      var localStorageId = parseInt(
        window.localStorage.getItem("defaultWeatherStation" + cropr.farm.id)
      );

      selectedStation = stations.find((station) => {
        return station.id === localStorageId;
      });

      if (!selectedStation) {
        const sorted = sortBy(stations, "name");
        selectedStation = sorted[0];
      }

      dispatch(
        selectFetchStation(
          apiUrl,
          selectedStation.id,
          selectedStation.show_all_measurements,
          selectedStation.show_five_minutes_measurements
        )
      );
      return dispatch(receiveStations(stations));
    } catch (err) {
      return dispatch(failedStations());
    }
  };
};

const weatherStationsActions = { fetchStations, selectStation, selectFetchStation };

export default weatherStationsActions;
